export default __webpack_public_path__ + "static/media/gbTDTC.4456c337.png";